import React from "react";
import LottieLoader from "../../lottie/LottieLoader";

const Loading = () =>
    <span className="loading-5d">
        <LottieLoader
            loop={true}
            src={require("../../../assets/lottie/loading.json")}/>
    </span>;
export default Loading;